import { BrowserRouter as Router } from "react-router-dom"
import Header from "@/layout/main/header/Header"
import AppRoutes from "@/routes/appRoutes"
import Sidebar from "@/layout/main/sidebar/Sidebar"
import { ThemeProvider } from "@mui/material/styles"
import theme from "@/themes/theme"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import React from "react"
import AlertBox from "components/common/alert/AlertBox"
import { useAppDispatch, useAppSelector } from "@/hooks/reduxToolkitHook"
import { closeAlert } from "@/redux/features/alertsSlice"

const App = () => {
  const alert = useAppSelector(state => state.alerts.alert)
  const dispatch = useAppDispatch()

  return (
    <ThemeProvider theme={theme}>
      {/*<LocalizationProvider dateAdapter={AdapterDateFns}>*/}
        <AlertBox
          type={alert.type}
          open={alert.is_fired}
          onClose={() => dispatch(closeAlert())}
          message={alert.message}
        />
        <div className="">
          <Router>
            {/*<ProtectedRoute>*/}
            <main className="flex w-full">
              <Sidebar />
              <div className="flex-[4] bg-blueCover overflow-y-auto relative">
                <Header />
                <div className=" mx-8 min-h-screen py-2 space-y-6 overflow-y-auto text-black4">
                  <AppRoutes />
                </div>
              </div>
            </main>
            {/*</ProtectedRoute>*/}
          </Router>
        </div>
      {/*</LocalizationProvider>*/}
    </ThemeProvider>
  )
}

export default App
